
import AcompanhamentoVendas from "@/components/relatorios/AcompanhamentoVendas.vue";
import HistoricoDeStatus from "@/components/relatorios/HistoricoDeStatus.vue";
import VendasPorDia from "@/components/relatorios/VendasPorDia.vue";
import VendasPorPeriodo from "@/components/relatorios/VendasPorPeriodo.vue";
import Recorrencia from "@/components/relatorios/Recorrencia.vue";

export default {
  components: {
    AcompanhamentoVendas,
    HistoricoDeStatus,
    VendasPorDia,
    VendasPorPeriodo,
    Recorrencia
  },
  name: "Relatorios",
  data: () => ({
    navigation: [
      {
        name: "Planilha de Acompanhamento",
        route: "/relatorios/acompanhamento-de-vendas",
        icon: "mdi-calendar-month"
      },
      {
        name: "Vendas por dia",
        route: "/relatorios/vendas-por-dia",
        icon: "mdi-calendar-today"
      },
      {
        name: "Vendas por periodo",
        route: "/relatorios/vendas-por-periodo",
        icon: "mdi-calendar-range"
      },
      {
        name: "Histórico Geral",
        route: "/relatorios/historico-de-vendas",
        icon: "mdi-history"
      },
      {
        name: "Recorrência",
        route: "/relatorios/recorrencia",
        icon: "mdi-credit-card-outline"
      }
    ]
  })
};
